import { useState } from "react";
import { useReveal } from "@/hooks/useReveal";
import { IMAGES } from "@/data/content";
import { Zap, Sun, GraduationCap } from "lucide-react";

const TABS = [
  {
    key: "stages", label: "Stages", icon: Zap, img: IMAGES.breakStage,
    title: "Stages intensifs & perfectionnement",
    text: "Des stages tout au long de l'année pour progresser vite dans les disciplines de la culture hip-hop. Animés par nos profs et des invités de la scène, ils sont ouverts à tous les niveaux.",
    points: ["Vacances scolaires", "Tous niveaux", "Invités & battles"],
  },
  {
    key: "sejours", label: "Séjours", icon: Sun, img: IMAGES.studioGroup,
    title: "Séjours & bootcamps d'été",
    text: "Plusieurs séjours dans l'année : bootcamps d'été, immersion totale dans la danse et la culture, dans une ambiance de colonie où l'on crée des souvenirs et des liens qui durent.",
    points: ["Immersion totale", "Vie de groupe", "Créations collectives"],
  },
  {
    key: "formations", label: "Formations", icon: GraduationCap, img: IMAGES.stageGroup,
    title: "Formations professionnelles",
    text: "L'AJDR est un centre certifié qui propose des formations diplômantes : BAFA, BPJEPS et parcours d'animateur. Fais de ta passion un métier et transmets à ton tour.",
    points: ["BAFA", "BPJEPS", "Certifié Qualiopi"],
  },
];

export function Workshops() {
  const head = useReveal();
  const [tab, setTab] = useState("stages");
  const active = TABS.find((t) => t.key === tab);
  const Icon = active.icon;
  return (
    <section id="stages" data-testid="workshops-formations-section" className="relative py-20 md:py-28 bg-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div ref={head.ref} className={head.className}>
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-emerald-bright mb-3">Aller plus loin</p>
          <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tight max-w-3xl">
            Stages, séjours <span className="text-mustard">& formations</span>
          </h2>
        </div>

        <div className="mt-10 flex flex-wrap gap-2">
          {TABS.map((t) => (
            <button
              key={t.key}
              data-testid={`workshop-tab-${t.key}`}
              onClick={() => setTab(t.key)}
              className={`inline-flex items-center gap-2 rounded-full px-5 py-2 text-sm font-sub transition ${
                tab === t.key ? "bg-mustard text-ink font-semibold" : "bg-ink-2 text-cream/70 border border-white/10 hover:border-mustard/50"
              }`}
            >
              <t.icon className="w-4 h-4" /> {t.label}
            </button>
          ))}
        </div>

        <div className="mt-8 grid lg:grid-cols-2 gap-8 items-center">
          <div className="relative rounded-3xl overflow-hidden min-h-[300px]">
            <img src={active.img} alt={active.title} className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-tr from-ink/80 to-transparent" />
          </div>
          <div>
            <div className="w-12 h-12 rounded-xl bg-mustard/15 flex items-center justify-center mb-5">
              <Icon className="w-6 h-6 text-mustard" />
            </div>
            <h3 className="font-display font-bold text-2xl md:text-3xl text-cream">{active.title}</h3>
            <p className="mt-4 text-cream/70 leading-relaxed">{active.text}</p>
            <div className="mt-6 flex flex-wrap gap-2">
              {active.points.map((p) => (
                <span key={p} className="tag-emerald rounded-full px-3 py-1 text-xs font-mono2">{p}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
